import { Button } from "grommet";
import styled from "styled-components";
import { Colors } from "../consts";

const PrimaryButton = styled(Button).attrs(() => ({ primary: true }))`
  color: ${Colors.overBrand};
`;

export default PrimaryButton;
